export default {
  users: [],
  user: {},
  email: '',
  password: '',
  tel: '',
  name: '',
  birthDayYear: 1900,
  birthDayMonth: 1,
  birthDayDate: 1,
  country: null,
  prefecture: null,
  address: '',
  admin: false
}
